import { TranslationDto } from "./translation.dto"

export class AppVersionDto {
  id: number
  versionNumber: string
  iosVersionNumber: string
  androidVersionNumber: string
  forceUpdate: boolean
  optionalUpdate: boolean
  iosStoreUrl: string
  androidStoreUrl: string
  enabled: boolean
  type: string
  createdAt: Date
  updatedAt: Date
}

export class AndroidAppVersionReleaseDto {
  name: string
  versionCodes: string[]
  releaseNotes: any[]
  status: string
  inAppUpdatePriority: number
}

export class AndroidAppVersionDto {
  track: string
  releases: AndroidAppVersionReleaseDto[]
}

export class CreateAppVersionDto {
  versionNumber?: string
  androidVersionNumber: string
  iosVersionNumber: string
  forceUpdate: boolean
  optionalUpdate?: boolean 
}

export class SubmitAndroidPublisherTrackDto {
  name: string
  versionCode: string
  releaseNote: TranslationDto
  inAppUpdate: number
}

export class UpdateAppVersionDto {
  versionNumber?: string
  iosVersionNumber?: string
  androidVersionNumber?: string
  forceUpdate?: boolean
  optionalUpdate?: boolean 
}